import styled from 'styled-components';

export const RenameListStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const RenameContainerStyle = styled.div`
  display: flex;
  align-items: flex-end;
  gap: 6px;

  label {
    width: 233px;
    display: flex;
    flex-direction: column;
    gap: 4px;

    span {
      color: #25262b;
      font-size: 12px;
      font-weight: 600;
      line-height: 18px;
      text-align: left;
    }
  }

  .arrow {
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      width: 16px;
      height: 16px;
    }
  }

  .actions {
    display: flex;
    gap: 6px;

    /* button {
      background-color: #f3f3ff;
      border-radius: 6px;
      outline: none;
      border: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 24px;
      height: 24px;

      &:first-child {
        svg {
          width: 24px;
          height: 24px;
          transform: scale(1.6);
          path {
            stroke: black;
          }
        }
      }

      svg {
        width: 24px;
        height: 24px;
      }
    } */
  }
`;

export const JoinTables = styled.div`
  display: flex;
  width: 100%;
  gap: 8px;

  .table {
    display: flex;
    align-items: center;
    gap: 4px;

    .first_table {
      border-radius: 4px;
      background: #fff;
      padding: 4px 6px;
      width: 137px;
      height: 26px;
      color: #000;
      font-size: 12px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      display: flex;
      align-items: center;
      border: 1px solid #ced4da;
    }

    .form-element {
      width: 117px;

      .select {
        background: #fff;
      }
    }

    label {
      color: #25262b;
      font-size: 12px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
`;

export const JoinTypes = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 6px;
  border-radius: 6px;
  gap: 16px;

  .types {
    width: 100%;
    display: flex;
    gap: 32px;
    flex-wrap: wrap;

    .type {
      width: 169px;
      height: 120px;
      border-radius: 4px;
      background: #fff;
      cursor: pointer;
      border: 1px solid #e9ecef;
      outline: none;
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      padding: 12px;
      justify-content: space-between;
      position: relative;

      .icon {
        svg {
          min-width: 63px;
          min-height: 42px;
        }
      }

      .text {
        color: #868e96;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 140%; /* 19.6px */
        text-align: left;
      }

      .toggle {
        position: absolute;
        top: 12px;
        right: 12px;
      }

      &.active {
        border: 1px solid #a5d8ff;
        background: #e7f5ff;
      }
    }
  }
`;

export const JoinConditions = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #f1f3f5;
  padding: 16px 0;

  .title {
    color: #2b313d;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .conditions {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
    gap: 6px;

    .condition {
      display: flex;
      align-items: flex-end;
      justify-content: flex-start;
      overflow-x: scroll;
      // gap: 16px;
      // min-width: 612px;

      .form-element {
        min-width: 105px;
        width: auto;
        max-width: 100%;

        .select {
          background: #cde0ff;
        }
      }

      .table {
        display: flex;
        flex-direction: column;
        gap: 4px;
        min-width: 178px;

        label {
          color: #5c5d61;
          font-size: 10px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
        }
      }

      .operator {
        color: #000;
        font-size: 16px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        margin-bottom: 8px;
      }
    }
  }
`;

export const JoinResultColumns = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #f1f3f5;
  padding: 16px 0;
  gap: 16px;

  .warning {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #6f6f6f;
    font-size: 14px;

    svg {
      path {
        stroke: red;
      }
    }
  }

  .title {
    color: #2b313d;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }

  .box {
    min-height: 72px;
    max-height: 250px;
    overflow-y: auto;
    display: flex;

    .columns {
      width: 50%;
      display: flex;
      flex-direction: column;
      gap: 16px;

      .column-title {
        color: #5c5d61;
        font-size: 10px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }

      .checkbox {
        display: flex;
        align-items: center;
        gap: 4px;

        span {
          color: #5c5d61;
          font-size: 10px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          margin-bottom: 2px;
        }
      }
    }
  }
`;

export const CategoryList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  border-radius: 6px;
  background: #fff;
  padding: 0 8px 8px 8px;
  width: auto;
  max-width: 800px;
  transform: translateX(80px);
  max-height: 400px;
  overflow-y: auto;
  min-height: 250px;
  position: relative;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);

  .multiple-search__input {
    font-size: 9px;
  }

  .multiple-search__menu-item {
    button {
      font-size: 9px;
    }
  }

  table {
    width: 100%;

    thead {
      position: sticky;
      top: 0;
      background: #fff;

      tr {
        th {
          padding-top: 8px;
          padding-bottom: 5px;
          padding-right: 10px;
          max-width: 150px;

          span {
            margin-bottom: 10px;
          }
        }
      }
    }

    tbody {
      width: 100%;

      tr {
        width: 100%;
        border-radius: 3px;
        border-bottom: 1px solid #c1c1c1;
        background: #fff;
        margin-top: 4px;
        cursor: pointer;
        padding: 4px;

        &.selected {
          border-radius: 3px;
          background: #007aff36;
        }

        &.active {
          border-radius: 3px;
          background: #007aff36;

          td {
            svg {
              transform: rotate(90deg);
            }
          }
        }

        td {
          color: #5c5d61;
          font-size: 10px;
          font-style: normal;
          font-weight: 500;
          line-height: normal;
          padding: 4px;

          div {
            display: flex;
            align-items: center;
            justify-content: space-between;
          }

          span {
            width: 85%;
            overflow: hidden;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
        }
      }
    }

    thead {
      width: 100%;

      tr {
        width: 400px;

        th {
          width: 90px;
          color: #2b313d;
          font-size: 10px;
          font-style: normal;
          font-weight: 600;
          line-height: normal;
        }
      }
    }
  }
`;

export const TableContainer = styled.div`
  width: 129px;
  border-radius: 6px;
  box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.3);
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 4px;
  transform: translateX(195px) translateY(-10px);

  span {
    color: #2b313d;
    font-size: 10px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
  }
`;

export const TableList = styled.ul`
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;

  li {
    margin-top: 4px;
    border-bottom: 1px solid #c1c1c1;
    background: #fff;
    padding: 6px;

    color: #5c5d61;

    font-size: 10px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    cursor: pointer;

    &.selected {
      background: #007aff36;
    }
  }
`;
